import { isMobile, isIOS } from 'react-device-detect';
import Logger from '../../services/Logger';
import picsioConfig from '../../../../../config';
import { defaultPresets, customPreset } from '../../components/DialogPresets/config';

const { isMainApp } = picsioConfig;

const setArchiveAndWatermarkSettings = (preset, isArchive = true, withoutWatermark = false) => ({
  ...preset,
  data: {
    ...preset.data,
    isArchive,
    withoutWatermark,
  },
});

/**
 * Split server presets so curated defaults (`isDefault: true`) render before
 * user-created ones in the dropdown. Relative order inside each group is
 * preserved (server returns them in insertion order).
 */
function splitByDefault(downloadPresets = []) {
  const defaults = [];
  const custom = [];
  downloadPresets.forEach((p) => {
    if (p && p.isDefault) defaults.push(p);
    else custom.push(p);
  });
  return { defaults, custom };
}

/**
 * Preset list for download mode (matches legacy DownloadDialog.componentDidMount extensions).
 */
export default function buildDownloadModePresets({
  downloadPresets = [],
  shouldFormatBeDisabled,
  assets,
  countAssets,
}) {
  let presets;
  if (shouldFormatBeDisabled) {
    presets = [...defaultPresets];
  } else if (isMainApp) {
    // Order: Original, Custom, server defaults (isDefault:true), user-created.
    const { defaults: serverDefaults, custom: userPresets } = splitByDefault(downloadPresets);
    presets = [...defaultPresets, customPreset, ...serverDefaults, ...userPresets];
  } else {
    // Proofing / public website: offer the built-in "Original" + "Custom" slots
    // so the viewer can unlock conversion settings without seeing another
    // user's saved presets.
    presets = [...defaultPresets, customPreset];
  }

  let hasPdfProxyPresets = false;
  let hasCustomVideoPresets = false;

  if (countAssets > 1 && isMobile && isIOS) {
    presets = presets.map((preset) => setArchiveAndWatermarkSettings(preset));
  }

  if (assets.every((asset) => !!asset.pdfProxies)) {
    presets = [
      ...presets,
      {
        _id: 'downloadPdf',
        name: 'Download as PDF',
        data: {
          usePdfProxy: true,
          mimeType: 'original',
          isArchive: false,
          withoutWatermark: false,
          organizeByCollections: false,
        },
      },
    ];
    hasPdfProxyPresets = true;
  }

  if (isMainApp && assets.every((a) => !!a.customVideo)) {
    const assetsQualities = assets.map((a) => {
      if (Array.isArray(a.customVideo.head)) {
        return a.customVideo.head.map((q) => q.quality);
      }
      return null;
    });
    if (!assetsQualities.includes(null)) {
      const diff = assetsQualities.reduce((acc, q, index) => {
        if (index === 0) return q;
        return acc.filter((i) => q.indexOf(i) > -1);
      }, []);
      if (diff.length > 0) {
        const videoPresets = diff.map((resolution) => ({
          _id: resolution.toString(),
          name: `${resolution}p`,
          data: {
            resolution,
            mimeType: 'original',
            isArchive: false,
            withoutWatermark: false,
            organizeByCollections: false,
          },
        }));
        presets = [...presets, ...videoPresets];
        hasCustomVideoPresets = true;
      } else {
        Logger.info('Download dialog: videos has no the same qualities');
      }
    } else {
      Logger.info('Download dialog: some video includes custom video without qualities');
    }
  }

  return {
    presets: presets.map((preset) => ({
      ...preset,
      data: { ...preset.data },
    })),
    hasPdfProxyPresets,
    hasCustomVideoPresets,
  };
}
